import React from 'react';
import DnsIcon from '@material-ui/icons/Dns';
import Fab from "@material-ui/core/Fab";

export default function Server  (){
    
  
    return (
        <>
        <div className="navbar-dark" style={{color:"white",backgroundColor:"#343A40"}}>
        
       
        <br/>
        <center>
        <input
            type="text"
            disabled
            value="How to choose servers"
            style={{
              height: "57px",
              width: "200px",
              borderRadius: "5px",
              padding: "20px",
              color:"white",
              
              background: "#212121",
              border: "2px",
            }}
          />
            <Fab
            color="primary"
            
            style={{
              background: "#b71c1c",
              borderRadius: "7px",
              
            }}
            
          >
            <DnsIcon />
          </Fab>
          </center>
          <br/>
        </div>
        <div style={{color:"gray",backgroundColor:"#212121",height:"150%"}}>
          <br/>
          
         <ol>
           <li><b>Server 1</b></li>
           <i>Best for Hollywood Movies with avg resolution of 480p to 720p with least buffering time and Ads.</i>
           <hr/>
           <li><b>Server 2</b></li>
           <i>Best for Hollywood & Bollywood Movies with 720p ,but with more buffering time and Ads.</i>
           <hr/>
           <li><b>Server 3</b></li>
           <i>Best for Hollywood & Bollywood Movies with 720p ,but with more buffering time and Ads.</i>
           <hr/>
           <li><b>Server 4</b></li>
           <i>Limited  Hollywood Movies with 720p resolution. </i>
           <hr/>
           <li><b>Server 5</b></li>
           <i>Most Ads (Recommended to use Adblocker) , best for  Hollywood & Bollywood Movies with 720p (vidlox,myStream,upStream)</i>
           <hr/>
           <li><b>HQ</b></li>
           <i>Direct Torrent streaming , but with limited Hollywood Movies (depending on seeders and leechers) with BluRay Full HD Resolution . Press Once and close and press again to stream  </i>
            <br/>
         </ol>

        </div>



      
        </>
    )

}